export default class FormatUtils {
    public static formatMoney(moneyValue: number | string): string {
        const moneyValueValidated = this.enterValueValidations(moneyValue);

        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(moneyValueValidated);
    }

    public static formatReference(value: number | string): string {
        const valueValidated = this.enterValueValidations(value);

        if (valueValidated === 0) {
            return '';
        }

        return new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(valueValidated);
    }

    public static enterValueValidations(value: string | number | null): number {
        if (value === null) {
            return 0;
        }

        if (typeof value == 'string') {
            return parseFloat(value);
        }

        return value;
    }
}